import React from 'react';
import { CircleLoader } from 'react-spinners';

interface IFullLoading {
  message?: string;
  show: boolean;
}

export default function FullLoading(props: IFullLoading) {
  return (
    <>
      {props.show && (
        <div
          style={{
            position: 'fixed',
            width: '100%',
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
            backgroundColor: 'rgba(255,255,255,0.7)',
            zIndex: 9999,
          }}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column',
              height: '100%'
            }}>
            <CircleLoader color='#0072bb' />
            {props.message && <h2>{props.message}</h2>}
          </div>
        </div>
      )}
    </>
  );
}
